"use client";

import { useRef, useState } from "react";
import { Form, Input, Button, Select, message } from "antd";
import { useRouter } from "next/navigation";
import { X } from "lucide-react";

const { Option } = Select;

export default function FloatingContactForm({ url,initialWebsite }: any) {
  const formRef = useRef<any>(null);
  const router = useRouter();
  const [visible, setVisible] = useState(true);
  const [submitting, setsubmitting] = useState(false);
  // console.log('url is ',url)

  const handleSubmit = async (values: any) => {
    setsubmitting(true)
    if (!window.grecaptcha) {
      message.error("reCAPTCHA failed to load. Please refresh the page.");
      return;
    }

    try {
      const token = await window.grecaptcha.execute(
        "6Ld9Q7kqAAAAACUZQAsyTE39c4sKSsf66u5um8MX",
        { action: "submit" }
      );

      const fullPhone = `${values.phoneCode}${values.phoneNumber}`;

      if (values.phoneNumber.length !== 10) {
        message.error("Phone number must be exactly 10 digits!");
        return;
      }
      const response = await fetch(
        "https://api.hsforms.com/submissions/v3/integration/submit/20095080/da377d09-b029-4fc4-9509-3cbc37a39d34",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fields: [
              { name: "firstname", value: values.firstName },
              { name: "lastname", value: values.lastName },
              { name: "email", value: values.email },
              { name: "phone", value: fullPhone },
              { name: "website", value: values.website },
            ],
          }),
        }
      );
      if (response.ok) {
        message.success(
          "Thank you for submitting your website SEO audit request. " +
          "Your report will be delivered to your email within 24 hours."+
          "Now you can enjoy our free seo tool",
          9
        );
        formRef.current.resetFields();
        setTimeout(() => {
          router.push(url);
        }, 9000);
      } else {
        message.error("Failed to submit form. Please try again.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      message.error("An unexpected error occurred.");
    }
    finally{
      setsubmitting(false)
    }
  };

  if (!visible) return null;

  return (
    <div className="bg-[url('/blog/form-bg.png')]  w-full bg-white rounded-xl p-5 2xl:p-10 py-14 bg-center bg-no-repeat bg-cover shadow-xl">
      {/* <button
        onClick={() => setsh(false)}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition"
      >
        <X size={20} />
      </button> */}

      <p className="text-white text-[24px] text-center 2xl:text-[28px] pb-5 font-semibold">
        Not sure which strategy is best for your business?
      </p>
      <span className="text-white text-[16px] block text-center pb-4">
        Let’s build a custom plan for you!
      </span>

      <Form ref={formRef} layout="vertical" onFinish={handleSubmit}>
        <div className="flex flex-col md:flex-row gap-4">
          <Form.Item
            name="firstName"
            className="w-full md:w-1/2"
            rules={[
              { required: true, message: "Please enter your first name" },
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Only alphabets are allowed",
              },
            ]}
          >
            <Input placeholder="Enter your first name" />
          </Form.Item>

          <Form.Item
            name="lastName"
            className="w-full md:w-1/2"
            rules={[
              { required: true, message: "Please enter your last name" },
              {
                pattern: /^[A-Za-z\s]+$/,
                message: "Only alphabets are allowed",
              },
            ]}
          >
            <Input placeholder="Enter your last name" />
          </Form.Item>
        </div>

        <div className="flex gap-4">
          <Form.Item
            name="phoneCode"
            className="w-[30%]"
            initialValue="+91"
            rules={[{ required: true, message: "Please select code" }]}
          >
            <Select
              showSearch
              placeholder="Select code"
              optionFilterProp="children"
            >
              <Option value="+1">+1 (United States/Canada)</Option>
              <Option value="+44">+44 (United Kingdom)</Option>
              <Option value="+91">+91 (India)</Option>
              <Option value="+61">+61 (Australia)</Option>
              <Option value="+81">+81 (Japan)</Option>
              <Option value="+49">+49 (Germany)</Option>
              <Option value="+33">+33 (France)</Option>
              <Option value="+86">+86 (China)</Option>
              <Option value="+7">+7 (Russia)</Option>
              <Option value="+39">+39 (Italy)</Option>
              <Option value="+34">+34 (Spain)</Option>
              <Option value="+971">+971 (UAE)</Option>
              <Option value="+880">+880 (Bangladesh)</Option>
              <Option value="+92">+92 (Pakistan)</Option>
              <Option value="+93">+93 (Afghanistan)</Option>
              <Option value="+94">+94 (Sri Lanka)</Option>
              <Option value="+62">+62 (Indonesia)</Option>
              <Option value="+63">+63 (Philippines)</Option>
              <Option value="+82">+82 (South Korea)</Option>
              <Option value="+66">+66 (Thailand)</Option>
              <Option value="+60">+60 (Malaysia)</Option>
              <Option value="+65">+65 (Singapore)</Option>
              <Option value="+55">+55 (Brazil)</Option>
              <Option value="+52">+52 (Mexico)</Option>
              <Option value="+27">+27 (South Africa)</Option>
              <Option value="+31">+31 (Netherlands)</Option>
              <Option value="+46">+46 (Sweden)</Option>
              <Option value="+41">+41 (Switzerland)</Option>
              <Option value="+234">+234 (Nigeria)</Option>
              <Option value="+20">+20 (Egypt)</Option>
              <Option value="+90">+90 (Turkey)</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            className="w-[70%]"
            rules={[
              { required: true, message: "Please enter your phone number" },
              { len: 10, message: "Phone number must be 10 digits" },
            ]}
          >
            <Input type="number" placeholder="Phone number" />
          </Form.Item>
        </div>

        <Form.Item
          name="email"
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Enter a valid email" },
          ]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>

        <Form.Item
          name="website"
          initialValue={initialWebsite || ""}
          rules={[
            { required: true, message: "Please enter your website URL" },
            { type: "url", message: "URL must start with http:// or https://" },
          ]}
        >
          <Input placeholder="https://example.com" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={submitting}
            disabled={submitting}
            className="w-full bg-pink rounded-full border-[1px] border-white text-white py-2 text-[16px] font-semibold  hover:!bg-pink hover:!border-white hover:!text-white"
          >
            Get A Free Seo Audit
          </Button>
        </Form.Item>
      </Form>

      {/* <div className="text-white mx-auto text-center text-[16px]">
        *We will get back to you within 3 days
      </div> */}
    </div>
  );
}
